module.exports = __webpack_public_path__ + "resources/DeviceManager-bd6fc2a9f71242ce626d7a5e143f2591.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/DeviceManager.png
// module id = 70
// module chunks = 0